export default __webpack_public_path__ + "static/210519_魔獄塔更新熱更完成公告_tc-9fa8dd1f5eefeaa3052b8b652e71c074.png";